import React from "react";
import ForgotPassword from "../../organisms/InitialPagesComponents/ForgotPassword/ForgotPassword";

const ForgotPasswordPage = () => {
  return <ForgotPassword />;
};

export default ForgotPasswordPage;
